import {
    CLEAR_CREDENTIALS, EMPTY_AUTH,
    FETCH_LOGGED_IN_USER, FETCH_LOGGED_IN_USER_SUCCESS, FETCH_LOGGED_IN_USER_FAILURE,
    FETCH_LOGIN, FETCH_LOGIN_SUCCESS, FETCH_LOGIN_FAILURE,
    FETCH_REQUEST_INVITATION, FETCH_REQUEST_INVITATION_SUCCESS, FETCH_REQUEST_INVITATION_FAILURE,
    FETCH_RESET_PASSWORD, FETCH_RESET_PASSWORD_SUCCESS, FETCH_RESET_PASSWORD_FAILURE,
    FETCH_SIGNUP, FETCH_SIGNUP_SUCCESS, FETCH_SIGNUP_FAILURE,
    SEND_FORGOT_PASSWORD_EMAIL, SEND_FORGOT_PASSWORD_EMAIL_SUCCESS, SEND_FORGOT_PASSWORD_EMAIL_FAILURE,
    SET_CREDENTIALS, SET_INVITATION_DATA, SET_TOKEN, SET_USER, UPDATE_AUTH
} from './constants';

import {
    SAVE_SUBSCRIPTION_SUCCESS
} from "../../Accounts/store/constants";

import clone from 'clone';

const emptyInvitationData = {
    email: null,
    firstName: null,
    lastName: null,
    description: null,
    isAgency: false
};

export const emptyUser = {
    brandExperience: null,
    company: null,
    email: null,
    firstName: null,
    lastName: null,
    notificationEmail: null,
    notificationNewMessages: false,
    notificationAccountUpdates: false,
    notificationBillingReminders: false,
    notificationFavoriteFreelancer: false,
    notificationsUseAccountEmail: true,
    password: null,
    password2: null,
    profilePicUrl: null
};

const emptyCredentials = {
    email: null,
    password: null
};

const initialState = {
    credentials: clone(emptyCredentials),
    user: clone(emptyUser),
    invitationData: clone(emptyInvitationData),
    isAuthenticating: false,
    isFetching: false,
    isRequestingInvitation: false,
    isResettingPassword: false,
    isSaving: false,
    isSendingForgotPasswordEmail: false,
    error: {},
    loginError: {},
    resetPasswordError: {},
    sendForgotPasswordEmailError: {},
    signupError: {},
    token: null
};

function authReducer(state = clone(initialState), action) {
    switch(action.type) {
        case CLEAR_CREDENTIALS:
            return Object.assign({}, state, {
                credentials: clone(emptyCredentials)
            });
        case EMPTY_AUTH:
            return clone(initialState);
        case FETCH_LOGGED_IN_USER:
            return Object.assign({}, state, {
                isFetching: action.showSpinner !== false,
                error: {}
            });
        case FETCH_LOGGED_IN_USER_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                user: action.data,
            });
        case FETCH_LOGGED_IN_USER_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case FETCH_LOGIN:
            return Object.assign({}, state, {
                isAuthenticating: true,
                loginError: {}
            });
        case FETCH_SIGNUP:
            return Object.assign({}, state, {
                isAuthenticating: true,
                signupError: {}
            });
        case FETCH_LOGIN_SUCCESS:
        case FETCH_SIGNUP_SUCCESS:
            return Object.assign({}, state, {
                isAuthenticating: false,
                user: action.data,
            });
        case FETCH_LOGIN_FAILURE:
            return Object.assign({}, state, {
                isAuthenticating: false,
                loginError: action.error
            });
        case FETCH_SIGNUP_FAILURE:
            return Object.assign({}, state, {
                isAuthenticating: false,
                signupError: action.error
            });
        case FETCH_REQUEST_INVITATION:
            return Object.assign({}, state, {
                isRequestingInvitation: true,
                error: {}
            });
        case FETCH_REQUEST_INVITATION_SUCCESS:
            return Object.assign({}, state, {
                isRequestingInvitation: false,
                invitationData: clone(emptyInvitationData)
            });
        case FETCH_REQUEST_INVITATION_FAILURE:
            return Object.assign({}, state, {
                isRequestingInvitation: false,
                error: action.error
            });
        case FETCH_RESET_PASSWORD:
            return Object.assign({}, state, {
                isResettingPassword: true,
                resetPasswordError: {}
            });
        case FETCH_RESET_PASSWORD_SUCCESS:
            return Object.assign({}, state, {
                isResettingPassword: false,
                credentials: action.data
            });
        case FETCH_RESET_PASSWORD_FAILURE:
            return Object.assign({}, state, {
                isResettingPassword: false,
                resetPasswordError: action.error
            });
        case SEND_FORGOT_PASSWORD_EMAIL:
            return Object.assign({}, state, {
                isSendingForgotPasswordEmail: true,
                sendForgotPasswordEmailError: {}
            });
        case SEND_FORGOT_PASSWORD_EMAIL_SUCCESS:
            return Object.assign({}, state, {
                isSendingForgotPasswordEmail: false
            });
        case SEND_FORGOT_PASSWORD_EMAIL_FAILURE:
            return Object.assign({}, state, {
                isSendingForgotPasswordEmail: false,
                sendForgotPasswordEmailError: action.error
            });
        case SET_CREDENTIALS:
            return Object.assign({}, state, {
                credentials: action.data
            });
        case SET_INVITATION_DATA:
            return Object.assign({}, state, {
                invitationData: action.data
            });
        case SET_TOKEN:
            return Object.assign({}, state, {
                cryptoToken: null,
                token: action.data
            });
        case SET_USER:
            return Object.assign({}, state, {
                user: action.data
            });
        case UPDATE_AUTH:
            return action.data;

        case SAVE_SUBSCRIPTION_SUCCESS:
            let user = clone(state.user);
            user.company = action.data;
            return Object.assign({}, state, {
                user
            });

        default:
            return state;
    }
}

export default authReducer;



// WEBPACK FOOTER //
// ./src/containers/Auth/store/reducers.js